import React from 'react';
import useCountdown from 'utils/useCountdown';

import { CountdownContainer, CountdownInnerContainer } from './styles';

const CountdownTimer = ({ date }) => {
  const countdown = useCountdown(date);

  return (
    <CountdownContainer>
      <CountdownInnerContainer>
        <div className="coundown-time days">
          <h1>{countdown.days}</h1>
          <h5>Days</h5>
        </div>
        <div className="coundown-time hours">
          <h1>{countdown.hours}</h1>
          <h5>Hours</h5>
        </div>
        <div className="coundown-time minutes">
          <h1>{countdown.min}</h1>
          <h5>Minutes</h5>
        </div>
        <div className="coundown-time seconds">
          <h1>{countdown.sec}</h1>
          <h5>Seconds</h5>
        </div>
      </CountdownInnerContainer>
    </CountdownContainer>
  );
};

export default CountdownTimer;
